<template lang="pug">
  .denmark
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/denmark_bg.jpeg"
      )
      span {{ gettext('Дания') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Дания – одна из богатейших развитых стран мира, которая является членом Евро Союза и относится к группе Скандинавских стран. Дания - страна с богатым историческим прошлым и является очень старым государством, которое остается независимым на протяжении 11 веков. За это время она сумела выстроить на своей территории современную процветающую демократию.') }}
        p {{ gettext('В Королевстве процветает социализм, страна всячески заботится о своих подданных в сферах здравоохранения, образования и социальной безопасности. Главные источники дохода государства – это сельское хозяйство и индустрия. Также высоко развиты торговля, транспорт и сфера услуг.') }}
        p {{ gettext('Датское население насчитывает около 5 с половиной миллиона человек и является этнически и культурно однородным.  Королевство Дания широко и радушно открывает свои врата перед огромным количеством иммигрантов из Восточной Европы. Только в 2018 году с этого региона въехало 690 420 человек, в основном поляков, румын, болгар, граждан стран Прибалтики и Украины. Около 75 % из них трудоустроены или проходят стажировку на высокоразвитых и передовых датских предприятиях. Легально работая в Дании, вы имеете право забрать к себе свою семью (супруга/супругу и несовершеннолетних детей). По прибытию он/она сможет трудоустроится или открыть собственный бизнес на территории Дании, получать образование.') }}
        P {{ gettext('Для успешной интеграции в Дании иностранцам предлагают посещать всевозможные мероприятия, обучаться в национальных школах датскому языку, истории и праву. Прожив в Дании больше 7 лет и сдав экзамен на знание языка, вы сможете получить датское гражданство.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/denmark_bg.jpeg'})
  },
  name: 'Denmark',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Denmark | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/denmark/index.vue